import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateShopReturnReasonDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateReturnReason(shop: ShopDto, reasonId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);
  const mutation = $api.useMutation("patch", "/shops/{shopId}/reasons/{reasonId}");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (variables: UpdateShopReturnReasonDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id, reasonId } },
        body: variables,
      });
    },
  });
}
